import React, { useCallback, useState } from 'react';
import _debounce from 'lodash-es/debounce';
import tw from 'twin.macro';
import { LivretEleve } from '@teetsh/app/src/containers/Livrets/types/livret';
import clsx from 'clsx';
import { SocleCommunDomaines } from './SocleCommunDomaines';
import { useTranslation } from 'react-i18next';

interface Props {
  livretEleve: LivretEleve;
  livretEvalId: string;
  onChange?: (p: LivretEleve) => void;
  readonly?: boolean;
  className?: string;
}

export function SocleCommunList(props: Props) {
  const { onChange, readonly, className, livretEvalId } = props;
  const { t } = useTranslation(['carnet']);
  const [value, setValue] = useState<LivretEleve>(props.livretEleve);
  const debouncedSave = useCallback(
    _debounce(nextValue => onChange && onChange(nextValue), 500),
    [onChange, props.livretEleve],
  );
  const handleChange = nextValue => {
    setValue(nextValue);
    debouncedSave(nextValue);
  };
  return (
    <div className={clsx(className)}>
      {(value.socle || []).length > 0 && (
        <div css={[tw`text-xl mb-2`]}>
          {t('carnet:livret.maitriseSocleCommun')}
        </div>
      )}
      <SocleCommunDomaines
        print={readonly}
        livretEleveId={props.livretEleve.id}
        livretEvalId={livretEvalId}
        value={value.socle || []}
        onChange={comps => handleChange({ ...props.livretEleve, socle: comps })}
      />
    </div>
  );
}
